var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1059_1174)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 36,
    r: 27,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1059_1174)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.8617 29.3759C47.4115 28.9258 46.9131 28.5319 46.3665 28.1943C46.0128 27.9772 45.5948 27.9129 45.1928 28.0094C44.7829 28.1139 44.4453 28.3711 44.2362 28.7329C44.1076 28.966 44.0353 29.2232 44.0353 29.4885C44.0353 30.0271 44.3086 30.5174 44.7668 30.7988C46.3022 31.7554 47.2186 33.4113 47.2186 35.212C47.2186 37.0126 46.3022 38.6685 44.7668 39.6251C44.0594 40.0673 43.8263 40.9756 44.2362 41.6911C44.5096 42.1653 45.016 42.4547 45.5626 42.4547C45.844 42.4547 46.1253 42.3743 46.3584 42.2296C48.8102 40.7103 50.2732 38.0898 50.2732 35.2039C50.2732 33.0013 49.4131 30.9274 47.8536 29.3679L47.8617 29.3759Z",
    fill: "url(#paint0_linear_1059_1174)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0707 37.3422C41.897 37.3422 40.9404 36.3936 40.9404 35.212C40.9404 34.0303 41.889 33.0817 43.0707 33.0817C44.2523 33.0817 45.2009 34.0303 45.2009 35.212C45.2009 36.3936 44.2523 37.3422 43.0707 37.3422Z",
    fill: "url(#paint1_linear_1059_1174)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2218 35.22C56.2218 40.3245 53.5289 44.802 49.4854 47.31C49.1961 47.4869 48.8745 47.5753 48.561 47.5753C47.942 47.5753 47.3391 47.2538 47.0015 46.675C46.5192 45.8309 46.8086 44.7698 47.6366 44.2473C50.651 42.3663 52.6526 39.0222 52.6526 35.22C52.6526 31.4177 50.643 28.0657 47.6366 26.1846C47.0819 25.839 46.7684 25.2441 46.7684 24.6332C46.7684 24.3357 46.8488 24.0383 47.0015 23.757C47.508 22.8808 48.6334 22.5914 49.4935 23.1219C50.426 23.7007 51.2861 24.384 52.0658 25.1637C54.6382 27.7361 56.2298 31.2891 56.2298 35.212L56.2218 35.22Z",
    fill: "url(#paint2_linear_1059_1174)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4133 24.5689H42.0017C42.2991 24.5689 42.5885 24.585 42.886 24.6091C43.5853 24.6654 44.2525 24.3278 44.5982 23.7249C45.2493 22.5914 44.5098 21.1686 43.2075 21.0561C42.8136 21.0239 42.4117 21.0078 42.0017 21.0078H34.4615C26.5917 20.9998 19.9438 27.4387 20.0001 35.3165C20.0242 39.1991 21.6159 42.72 24.1641 45.2683C26.7364 47.8406 30.2895 49.4323 34.2123 49.4323H42.0017C42.4036 49.4323 42.8056 49.4162 43.2075 49.384C44.5098 49.2715 45.2493 47.8487 44.5982 46.7152C44.2525 46.1123 43.5773 45.7747 42.886 45.831C42.5966 45.8551 42.2991 45.8712 42.0017 45.8712H34.2123C28.2557 45.8712 23.4245 40.9516 23.5692 34.9628C23.7059 29.1509 28.6014 24.577 34.4133 24.577V24.5689Z",
    fill: "url(#paint3_linear_1059_1174)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1078 42.7522L21.5435 49.3117C21.1336 50.3647 22.2348 51.3776 23.2477 50.8712L30.4422 47.294L24.1078 42.7522Z",
    fill: "url(#paint4_linear_1059_1174)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1059_1174",
    x: 0.6,
    y: 0.6,
    width: 74.8,
    height: 74.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1059_1174"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1059_1174",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1059_1174",
    x1: 40.9404,
    y1: 35.2156,
    x2: 56.2298,
    y2: 35.2156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA22FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9733EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1059_1174",
    x1: 40.9404,
    y1: 35.2156,
    x2: 56.2298,
    y2: 35.2156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA22FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9733EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1059_1174",
    x1: 40.9404,
    y1: 35.2156,
    x2: 56.2298,
    y2: 35.2156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA22FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9733EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1059_1174",
    x1: 19.9998,
    y1: 36.0067,
    x2: 44.8387,
    y2: 36.0067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0085FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0072FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1059_1174",
    x1: 19.9998,
    y1: 36.0067,
    x2: 44.8387,
    y2: 36.0067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0085FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0072FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1059_1174"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36.2219,
    height: 30,
    fill: "white",
    transform: "translate(20 21)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMm);
export default __webpack_public_path__ + "static/media/mm.454f92608484539cb3832260aba2d3d3.svg";
export { ForwardRef as ReactComponent };